<h3>Export Policy</h3>
<div *ngIf="projects && projects.length > 0">
  <div style="display: flex; flex-direction: row;" *ngIf="projects.length > 0" style="justify-content: center; align-items: center; margin-top: 10px">
    <mat-form-field style="width: 100%;">
      <mat-label>Export in Context of Project</mat-label>
      <mat-select  [(value)]="projectId">
        <mat-option [value]="0">No Context</mat-option>
        <mat-option *ngFor="let project of projects" style="display: block; cursor: pointer;"
                    [value]="project.projectId">{{project.name}}</mat-option>
      </mat-select>
    </mat-form-field>


  </div>
  <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; margin-top: 10px">
    <button mat-raised-button (click)="generate()">Ok</button>
    <button mat-raised-button (click)="onClose()">Cancel</button>
  </div>
</div>
